<template>
  <div class="relative min-h-screen bg-background-dark overflow-x-hidden">
    <PebbleContentNavbar />
    <slot />
  </div>
</template>
<script setup lang="ts">
</script>
